/**
 * dna — gemeinsame Klassen des Ausgaben-Moduls nach der gemessenen sevdesk-DNA
 * (docs/design-dna/ausgaben-sevdesk.json, Tokens `dna-*` in tailwind.config.js).
 */

export const FIELD = 'h-11 rounded-md border-dna-field bg-white text-[15px] text-dna-text placeholder:text-dna-placeholder focus-visible:ring-2 focus-visible:ring-dna-focus focus-visible:ring-offset-0';
export const SELECT = 'h-11 w-full rounded-md border border-dna-field bg-white px-2.5 text-[15px] text-dna-text focus:outline-none focus:ring-2 focus:ring-dna-focus';
export const LABEL = 'text-[13px] font-semibold text-dna-text';
export const SECTION_TITLE = 'text-[17px] font-semibold text-dna-primary';
export const CARD = 'rounded-xl border border-dna-line bg-white shadow-[0_1px_2px_rgba(34,34,67,0.06)]';
export const BTN_PRIMARY = 'h-11 gap-2 rounded-lg bg-dna-primary px-4 font-semibold text-white hover:bg-dna-primary-hover focus-visible:ring-2 focus-visible:ring-dna-focus';
export const BTN_SECONDARY = 'h-11 gap-2 rounded-lg border border-dna-line bg-white px-4 font-semibold text-dna-primary hover:bg-dna-warm focus-visible:ring-2 focus-visible:ring-dna-focus';
export const BTN_SMALL = 'h-9 gap-1.5 rounded-md border border-dna-line bg-white px-3 text-[13px] font-semibold text-dna-primary hover:bg-dna-warm';
export const LINK = 'font-semibold text-dna-link hover:underline focus-visible:underline focus-visible:outline-none';
export const TH = 'px-3 py-3 text-left text-[13px] font-semibold text-dna-muted';

/** Status-Badges: Pastell-Fläche + abgedunkelter Text (WCAG AA ≥ 5:1) */
export const BADGE = {
  draft: 'bg-dna-draft-bg text-dna-draft-fg',
  open: 'bg-dna-open-bg text-dna-open-fg',
  due: 'bg-dna-due-bg text-dna-due-fg',
  paid: 'bg-dna-paid-bg text-dna-paid-fg',
  partial: 'bg-dna-open-bg text-dna-paid-fg', // gelb (offen) + grüne Schrift (teilweise bezahlt)
  neutral: 'bg-dna-tab text-dna-muted',
};
